"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatPhoneNumber;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
var _startsFromAny = _interopRequireDefault(require("../../utils/string/startsFromAny"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatPhoneNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  if (value.substring(1).indexOf('+') !== -1) {
    return value.substring(0, 1) + value.substring(1).replace(/\+/g, '');
  }
  if ((0, _startsWith["default"])(value, '00')) {
    return value.replace(/^00/, '+');
  }
  if ((0, _startsWith["default"])(value, '+00')) {
    return value.replace(/^\+00/, '+');
  }
  if ((0, _startsWith["default"])(value, '+44')) {
    return value.substr(0, 13).replace(/[^+0-9]/g, '');
  }
  if ((0, _startsFromAny["default"])(value, ['07', '01', '02', '03', '08'])) {
    return value.substr(0, 11).replace(/[^+0-9]/g, '');
  }
  return value.replace(/[^+0-9]/g, '');
}